import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

// Confirmation shown when navigating away from a page with unsaved changes.
const UnsavedChangesDialog = ({ open, onDiscard, onStay }) => (
  <Dialog open={open} onClose={onStay}>
    <DialogTitle>Unsaved changes</DialogTitle>
    <DialogContent>
      <DialogContentText>
        You have unsaved changes on this page. If you leave now, they will be
        lost.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button color="error" onClick={onDiscard}>
        Discard & Leave
      </Button>
      <Button variant="contained" onClick={onStay}>
        Keep Editing
      </Button>
    </DialogActions>
  </Dialog>
);

export default UnsavedChangesDialog;
